import {
  SET_OTPMETHOD,
  SET_PASSWORD,
  SET_USERNAME,
} from "../actions/types";

const initialState = {
  username: null,
  password: null,
  otp_type: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERNAME:
      return {
        ...state,
        username: action.payload,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    case SET_OTPMETHOD:
      return {
        ...state,
        otp_type: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
